import Announcements from "../components/Announcements/Announcements";
import Box from "@mui/material/Box";
import Button from "../components/Button/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import ContactInfoList from "../components/Profile/ContactInfo/ContactInfoList";
import DefaultTemplate from "./templates/DefaultTemplate";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import { Link } from "react-router-dom";
import { OverviewCard } from "../components/Card/Card";
import PageTitle from "../components/PageTitle/PageTitle";
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
import TaxDocumentsList from "../components/Profile/TaxDocumentsList";
import Typography from "@mui/material/Typography";
import { connect } from "react-redux";
import useNavigateQSA from "../utils/hooks/useNavigateQSA";
import { useTheme } from "@mui/material";
import {
	ContentContainerBottom,
	ContentContainerTop
} from "./../components/Container/Container";
import { HELP_MODULE_FAQ, HELP_MODULE_KEY } from "../config/common";
import { format, isObject, isStringOfLength } from "@pheaa/channels-component-library";

const DEFAULT_GREETING = "Hi";

const IconQuestion = props => {
	return (
		<SvgIcon fill="none" sx={{ height: "82px", width: "68px" }} viewBox="0 0 68 82">
			<g clipPath="url(#clipPathId)">
				<path d="M27.29 69.23H13.31C11.63 69.23 10.27 67.87 10.27 66.19V53.46H2.34003C1.44003 53.46 0.790028 52.59 1.06003 51.72L7.38003 34.09C7.56003 33.58 7.65003 33.05 7.65003 32.51V31.45C7.65003 16.26 18.74 2.91001 33.83 1.19001C51.67 -0.849995 66.78 13.52 66.78 30.56C66.78 36.41 60.8 55.81 58.9 61.81C58.53 62.99 58.44 64.24 58.64 65.47L61.14 80.49" fill="white" stroke="black" strokeWidth="2" strokeLinejoin="round" />
				<path d="M36.94 52.95C48.7589 52.95 58.34 43.3689 58.34 31.55C58.34 19.7311 48.7589 10.15 36.94 10.15C25.1211 10.15 15.54 19.7311 15.54 31.55C15.54 43.3689 25.1211 52.95 36.94 52.95Z" fill="#0073B0" />
				<path d="M24.1699 81.62V69.23" stroke="black" strokeWidth="2" strokeMiterlimit="10" />
				<path d="M36.94 47.99C46.0196 47.99 53.38 40.6295 53.38 31.55C53.38 22.4704 46.0196 15.11 36.94 15.11C27.8604 15.11 20.5 22.4704 20.5 31.55C20.5 40.6295 27.8604 47.99 36.94 47.99Z" fill="#FFCC33" />
				<path d="M38.3001 37.3H35.7901V34.4C35.7901 33.77 35.9401 33.2 36.2301 32.67C36.5201 32.15 36.8801 31.66 37.2901 31.2C37.7101 30.75 38.1601 30.31 38.6501 29.89C39.1401 29.47 39.5901 29.02 39.9901 28.55C40.4001 28.07 40.7401 27.57 41.0201 27.03C41.3001 26.49 41.4401 25.88 41.4401 25.18C41.4401 23.99 41.0601 23.03 40.3101 22.28C39.5501 21.54 38.5701 21.16 37.3601 21.16C36.1501 21.16 35.1901 21.51 34.4101 22.21C33.6301 22.91 33.1401 23.83 32.9301 24.97L30.3101 24.66C30.4501 23.75 30.7201 22.94 31.1301 22.22C31.5401 21.5 32.0501 20.89 32.6701 20.39C33.2901 19.89 33.9901 19.51 34.7801 19.26C35.5701 19.01 36.4201 18.88 37.3301 18.88C38.2401 18.88 39.1301 19.01 39.9501 19.28C40.7601 19.55 41.4701 19.94 42.0601 20.45C42.6501 20.96 43.1201 21.6 43.4601 22.37C43.8001 23.14 43.9701 24.01 43.9701 24.99C43.9701 25.97 43.8301 26.79 43.5501 27.47C43.2701 28.14 42.9201 28.73 42.5001 29.23C42.0801 29.73 41.6301 30.18 41.1401 30.57C40.6501 30.96 40.2001 31.39 39.7801 31.84C39.3601 32.29 39.0101 32.81 38.7301 33.39C38.4501 33.97 38.3101 34.68 38.3101 35.52V37.3H38.3001ZM39.1401 42.33C39.1401 42.82 38.9701 43.26 38.6201 43.64C38.2701 44.02 37.8201 44.22 37.2601 44.22C36.7001 44.22 36.2501 44.03 35.9001 43.64C35.5501 43.25 35.3801 42.82 35.3801 42.33C35.3801 41.84 35.5501 41.41 35.9001 41.02C36.2501 40.63 36.7001 40.44 37.2601 40.44C37.8201 40.44 38.2701 40.63 38.6201 41.02C38.9701 41.4 39.1401 41.84 39.1401 42.33Z" fill="black" />
				<path d="M38.03 58H36.03V60H38.03V58Z" fill="black" />
				<path d="M38.03 63.12H36.03V65.12H38.03V63.12Z" fill="black" />
				<path d="M38.03 68.23H36.03V70.23H38.03V68.23Z" fill="black" />
			</g>
			<defs>
				<clipPath id="clipPathId">
					<rect width="67.78" height="81.62" fill="white" />
				</clipPath>
			</defs>
		</SvgIcon>
	);
};

const IconChevronRight = props => {
	const theme = useTheme();
	return (
		<SvgIcon {...props} viewBox="0 0 24 24">
			<path d="M6.23 20.23 8 22l10-10L8 2 6.23 3.77 14.46 12z" fill={theme.palette.primary.main}></path>
		</SvgIcon>
	);
};

const PDFViewerHelp = () => {
	return /*window.navigator && !window.navigator.pdfViewerEnabled &&*/ (
		<Typography mb={2} mt={3}>
			View PDF documents with <a className="external-link-icon" href="https://www.adobe.com/acrobat/pdf-reader.html" rel="noreferrer" target="_blank">Adobe Acrobat Reader</a>
		</Typography>
	);
};

const HomeView = ({ title, ...props }) => {

	let greeting = DEFAULT_GREETING;

	const { profileData } = props;
	const navigate = useNavigateQSA();

	const handleClick = e => {
		e.preventDefault();
		navigate({ search: { [HELP_MODULE_KEY]: HELP_MODULE_FAQ } });
	};

	if (isObject(profileData)) {
		if (isObject(profileData.iam) && isObject(profileData.iam.name) && isStringOfLength(profileData.iam.name.first)) {
			greeting = `Hi, ${format.asProperName({ first: profileData.iam.name.first })}`;
		}
	}

	return (
		<DefaultTemplate>
			<ContentContainerTop>
				<Box
					sx={{
						fontSize: 24,
						position: "absolute",
						right: 0,
						textAlign: "right",
						top: 10
					}}
				>
					Default Collections
				</Box>
				<PageTitle title={isStringOfLength(greeting) ? greeting : title} />
				<Announcements />
			</ContentContainerTop>
			<ContentContainerBottom>
				<Grid container mb={8} spacing={2}>
					<Grid item xs={12} md={6}>
						<OverviewCard
							content={<TaxDocumentsList maxListItems={4} />}
							headingAction={(
								<Button component={Link} to="/inbox">
									View All
								</Button>
							)}
							headingText="Inbox"
							paddingX={0}
						/>
						<PDFViewerHelp />
					</Grid>
					<Grid item xs={12} md={6}>
						<OverviewCard
							content={<ContactInfoList />}
							headingAction={(
								<Button component={Link} to="/profile">
									Edit
								</Button>
							)}
							headingText="Contact Information"
						/>
					</Grid>
				</Grid>
				<Typography component="h2" variant="h3">Need Help?</Typography>
				<Card
					sx={{
						borderRadius: 0,
						boxShadow: "none",
						marginTop: 2.5,
					}}
				>
					<Box
						sx={{
							alignItems: "center",
							display: "flex",
							justifyContent: "flex-start",
							padding: "18px 8px 18px 32px"
						}}
					>
						<IconQuestion />
						<Typography component="span" sx={{ flex: "1 1 auto", paddingLeft: 3 }}>
							Review our FAQ to get answers to your questions, or contact us for additional help.
						</Typography>
						<CardActions>
							<IconButton onClick={handleClick} title="Review our FAQ">
								<IconChevronRight />
							</IconButton>
						</CardActions>
					</Box>
				</Card>
			</ContentContainerBottom>
		</DefaultTemplate>
	);
};

const mapStateToProps = state => ({
	profileData: state.profile.data
});

export default connect(mapStateToProps)(HomeView);
export { IconChevronRight, PDFViewerHelp };